import type { ObjectLiteral } from 'api/submission';
import type { FEIN_FIELD_CODE, SSN_FIELD_CODE } from '../../common/constants';

export enum EInfoAiTypes {
  MORTGAGEE = 'Mortgagee',
  LOSS_PAYEE = 'Loss Payee',
}

export interface VehicleGroupField {
  isLeasedOrFinanced: boolean;
  info_ai_name: string;
  info_ai_address_phone: string;
  veh_vin?: string;
  info_ai_type: EInfoAiTypes;
  info_ai_subject: string | string[];
  is_added: boolean;
}

export interface PropertiesGroupField {
  hasLienHolder: boolean;
  info_ai_name: string;
  address: string;
  info_ai_type: EInfoAiTypes;
  info_ai_subject: string | string[];
  is_added: boolean;
}

export interface PurchaseFormValues extends ObjectLiteral {
  UnemploymentNumber?: string;
  hasUnemploymentNumber?: string;
  hasFein?: string;
  fein?: string;
  ssn?: string;
  [key: string]: VehicleGroupField | PropertiesGroupField | string | boolean | undefined;
}

export type OperationFieldInputType = typeof FEIN_FIELD_CODE | typeof SSN_FIELD_CODE | '';
